import React from "react";
import { Field, Form, Formik, FormikProps } from "formik";
import {
  Box,
  Button,
  Container,
  FormHelperText,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import ServerAlert from "../../../common/errors/ServerAlert";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import pageStyles from "../../pageStyles";
import Layout from "../../Layout";
import PageHeading from "../../../common/pageHeading/PageHeading";
import useSession from "../../../effects/useSession";
import { uploadFile } from "../../../store/terminal/actions";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";

export default function TerminalUpload(): React.ReactElement {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();
  const session = useSession();
  const location = useLocation();
  const [serverError, setServerError] = React.useState("");
  const [serverResponse, setServerResponse] = React.useState("");

  const uploadDataFromState = () => {
    if (location.state) {
      const { uploadObj } = location.state as any;
      return uploadObj;
    }
    return undefined;
  };

  const Results = (serverResponse: any): JSX.Element => {
    const rows = serverResponse.data.Terminal;
    if (!rows) {
      setServerError("No results received");
    }
    return (
      <Grid item xs={12}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Box
            display="flex"
            width="100%"
            flexDirection="column"
            m={2}
            className={classes.formSection}
          >
            <Box p={2} display="flex" alignItems="center">
              <Box flex={1}>
                <h2>Results</h2>
              </Box>
            </Box>
            <Box p={2}>
              <Paper>
                <Box p={2}>
                  <TableContainer component={Paper}>
                    <Table
                      style={{ minWidth: "650" }}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>Serial Number</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows &&
                          rows.map((row: any, i: number) => (
                            <TableRow key={i}>
                              <TableCell>{row.SerNo}</TableCell>
                              <TableCell>{row.Status}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Paper>
            </Box>
          </Box>
        </Grid>
      </Grid>
    );
  };

  const EditForm = () => {
    return (
      <Formik
        initialValues={uploadDataFromState()}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          const callback = (err: string | null, response: string | null) => {
            if (err) {
              setServerError(err);
            } else if (response) {
              setServerResponse(response);
            }
          };
          dispatch(uploadFile(values.file, callback));
        }}
      >
        {(props: FormikProps<any>) => {
          const { isSubmitting, values } = props;

          const isFileCorrect = () =>
            values?.file &&
            values.file?.data &&
            values.file.data?.Session &&
            values.file.data.Session?.Terminal &&
            values.file.data.Session.Terminal?.length > 0;

          return (
            <Form>
              <Grid container alignItems="flex-start" spacing={3}>
                <Grid item xs={4}>
                  <Field
                    name="name"
                    InputProps={{ readOnly: true }}
                    as={TextField}
                    label="File Name"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <Field
                    name="type"
                    InputProps={{ readOnly: true }}
                    as={TextField}
                    label="File Type"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <Field
                    name="file.data.Session.Terminal.length"
                    InputProps={{ readOnly: true }}
                    as={TextField}
                    label="Terminals in file"
                    fullWidth
                  />
                  {!isFileCorrect() && (
                    <FormHelperText error>
                      No Terminals found in file
                    </FormHelperText>
                  )}
                </Grid>
                {isSubmitting && (
                  <Grid item xs={12}>
                    <ProgressIndicator />
                  </Grid>
                )}

                {serverResponse && (
                  // @ts-ignore
                  <Results {...serverResponse} />
                )}

                <Grid item xs={12}>
                  <Box display="flex" justifyContent="flex-end">
                    <Box mr={2}>
                      <Button
                        variant="contained"
                        size="large"
                        onClick={() => history.goBack()}
                      >
                        {isSubmitting ? "Cancel" : "Go Back"}
                      </Button>
                    </Box>
                    {!(serverResponse || serverError) && (
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        type="submit"
                        disabled={isSubmitting || !isFileCorrect()}
                      >
                        Submit
                      </Button>
                    )}
                  </Box>
                  <ServerAlert serverError={serverError} />
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    );
  };

  return (
    <>
      <Layout sessionData={session}>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <Paper>
                  <PageHeading heading={"Import KIF terminal data"} />
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <EditForm />
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </main>
      </Layout>
    </>
  );
}
